<template>
    <div class="loc-1">
        <div class="topFlex" v-if="setTitle != '查看'">
            <div class="topLeft">
                <el-button type="info" @click="clearArea"
                    >清空电子围栏区域</el-button
                >
            </div>
            <div class="topRight">
                <el-button type="primary" class="ml20" @click="oldFeet"
                    >轨迹</el-button
                >
                <el-button type="primary" class="ml20" @click="drawArea"
                    >绘制电子围栏区域</el-button
                >
            </div>
        </div>
        <el-date-picker
            v-model="ctime"
            type="date"
            v-if="setTitle != '新增' || !this.formData.id"
            value-format="yyyy-MM-dd"
            @change="oldFeet"
            placeholder="选择日期">
        </el-date-picker>
        <div id="container2" style="width: 100%; height: 700px">
            <!-- <div class="tabBox">
                <el-table
                    :data="tableData"
                    border
                    style="width: 100%"
                    :header-cell-style="{
                        background: '#f2f2f2',
                        color: '#000',
                    }"
                >
                    <el-table-column
                        type="index"
                        width="70"
                        label="序号"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="createdTime"
                        label="时间"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="durnTime"
                        label="告警时长"
                        align="center"
                        :show-overflow-tooltip="true"
                    >
                    </el-table-column>
                </el-table>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        setTitle: {
            type: String,
            default: "",
        },
        formData: {},
        // gjInfo: {},
    },
    data() {
        return {
            ctime: null,
            tableData: [
                { createdTime: "2021-7-29 10:39:21 ", durnTime: "36分钟" },
                { createdTime: "2021-7-29 13:09:56 ", durnTime: "12分钟" },
            ],
            myMap: null,
            isMap: true,
            polygons: [],
            polygon: [],
            polygonArr: [],
            marker: null, //地图标记点
            markers: [],
            object3Dlayer: {},
            line3D: {},
            mouseTool: null,
            infoWindow: null,
            addForm: { pointPosition: "" },
            typeList: [
                { value: "1", label: "普通客户" },
                { value: "3", label: "残联服务对象" },
                { value: "4", label: "老干服务对象" },
                { value: "6", label: "政府援助客户" },
                { value: "7", label: "商业服务对象" },
                { value: "8", label: "D类援助客户" },
                { value: "10", label: "文明办服务对象" },
                { value: "13", label: "军人事务局服务对象" },
            ],
            watchLongitude: "",
            watchLatitude: "",
            records: [],
            guijiArr:[],
            map2:null,
        }
    },

    watch: {
        formData: {
            handler(val) {
                if (val.watchLongitude && val.watchLatitude && val.records) {
                    this.watchLongitude = val.watchLongitude
                    this.watchLatitude = val.watchLatitude
                    // this.records = val.records
                }
                this.getPolygon().then((res) => {
                    this.polygon =
                        val.pointPosition == null || val.pointPosition == ""
                            ? []
                            : val.pointPosition.split(",")
                })
            },

            deep: true,
            immediate: true,
        },
    },
    created() {
    },
    mounted() {
        this.inti()
    },
    methods: {
        //加载地图
        getmap2(data) {
            var marker,lineArr = this.guijiArr;
            let self = this
            // this.map2 = new AMap.Map(container2, {
            //     resizeEnable: true,
            //     zoom: 17,
            // });

            // marker = new AMap.Marker({
            //     map: this.map2,
            //     position: this.guijiArr[0],
            //     icon: require("./img/轨迹老人.png"),
            //     offset: new AMap.Pixel(-6, -26),
            // });
             self.marker = new AMap.Marker({
                map: this.map2,
                position: this.guijiArr[0],
                icon: require("./img/轨迹老人.png"),
                offset: new AMap.Pixel(-6, -26),
            })
            self.myMap.add(self.marker)
            self.myMap.setFitView()

            // 绘制轨迹
            var polyline = new AMap.Polyline({
                map: this.map2,
                path: lineArr,
                showDir: true,
                strokeColor: "red", //线颜色
                // strokeOpacity: 1,     //线透明度
                strokeWeight: 2, //线宽
                // strokeStyle: "solid"  //线样式
            });

            var passedPolyline = new AMap.Polyline({
                map: this.map2,
                strokeColor: "red", //线颜色
                strokeWeight: 2, //线宽
            });
            let that = this;
            if (data) {
                marker.on("click", function () {
                    let content =
                        `<div style="font-size:13px; color:#333">
            									<div>设备详情</div>
            									<ul>
            									  <li>设备名称：` +
                        data.equipmentName +
                        `</li>
            									  <li>时间：` +
                        data.updateTime +
                        `</li>
            									</ul>
            								</div>`;
                    that.infoWindow = new AMap.InfoWindow({
                        content: content,
                    });

                    //将marker放到指定坐标
                    that.infoWindow.open(that.map2, [
                        data.longitude,
                        data.latitude,
                    ]);
                });
            }

            marker.on("moving", function (e) {
                passedPolyline.setPath(e.passedPath);
            });

            this.map2.setFitView();

            marker.moveAlong(lineArr, 2000);
        },

        setPoint(item, index, data) {
            if (index == 0) {
                let icon = new AMap.Icon({
                    size: new AMap.Size(25, 34),
                    image: require("./img/marker.png"),
                    imageSize: new AMap.Size(135, 40),
                    imageOffset: new AMap.Pixel(-10, -3),
                });
                var marker = new AMap.Marker({
                    map: this.map2,
                    draggable: true,
                    // position: [116.478935,39.997761],
                    position: [item.longitude, item.latitude],
                    icon: icon,
                });
            } else if (index == data.length - 1) {
                let icon = new AMap.Icon({
                    size: new AMap.Size(25, 34),
                    image: require("./img/marker.png"),
                    imageSize: new AMap.Size(135, 40),
                    imageOffset: new AMap.Pixel(-95, -3),
                });
                var marker = new AMap.Marker({
                    map: this.map2,
                    draggable: true,
                    // position: [116.478935,39.997761],
                    position: [item.longitude, item.latitude],
                    icon: icon,
                });
            } else {
                var marker = new AMap.CircleMarker({
                    center: [item.longitude, item.latitude],
                    radius: 6, //3D视图下，CircleMarker半径不要超过64px
                    strokeColor: "white",
                    strokeWeight: 3,
                    strokeOpacity: 1,
                    fillColor: "red",
                    fillOpacity: 1,
                    zIndex: 90,
                    bubble: true,
                    cursor: "pointer",
                    clickable: true,
                });
            }
            let that = this;
            marker.on("click", function () {
                let content =
                    `<div style="font-size:13px; color:#333">
            									<div style="text-align: center; height:30px; line-height:25px">老人详情</div>
            									<ul style=" line-height:25px">
            									  <li>姓名：` +
                    that.tubiaoInfo.person_name +
                    `</li>
            									  <li>时间：` +
                    item.updateTime +
                    `</li>
            									</ul>
            								</div>`;
                that.infoWindow = new AMap.InfoWindow({
                    content: content,
                });

                //将marker放到指定坐标
                that.infoWindow.open(that.map2, [
                    item.longitude,
                    item.latitude,
                ]);
            });

            this.markers.push(marker);
            this.map2.add(this.markers);
        },


        wUpdata() {
            this.$emit("getGjInfo", this.addForm)
        },
        async inti() {
            await this.loadMap().then((res) => {
                // if (this.formData.id) {
                // this.getPont()
                this.getPolygon()
                // this.getLines()
                this.potintMaps()
                this.oldFeet()
            })
        },
        // 轨迹
        oldFeet() {
            if (this.formData.id) {
                this.$http.request({
                    url:"/jjyl/admin/all/watchLocation/info/get",
                    method:"post",
                    data:{
                        equipmentId: this.formData.id,
                        ctime:this.ctime
                    }
                }).then(res =>{
                    if(res.code == 200){
                        if (res.content) {
                            this.records = res.content
                            this.getLines()
                        }
                    }
                })
            }
        },
        // 绘制电子围栏区域
        drawArea() {
            const that = this
            if (this.polygon.length > 0) {
                return this.$message.warning("请先删除已有区域")
            }
            this.mouseTool.close(true)
            this.mouseTool.polygon()
            this.drawFun()
        },
        drawFun() {
            const that = this
            this.mouseTool = new AMap.MouseTool(this.myMap)
            this.mouseTool.on("draw", function (e) {
                //监听draw事件可获取画好的覆盖物
                that.polygonArr = []
                e.obj.getPath().forEach((element) => {
                    that.polygonArr.push([element.lng, element.lat])
                })
                let s = []
                that.polygonArr.forEach((e) => {
                    s.push(`${e[0]}:${e[1]}`)
                })

                that.addForm.pointPosition = s.join()
                that.wUpdata()
            })
            this.mouseTool.polygon({
                fillColor: "#00b0ff",
                strokeColor: "#80d8ff",
                //同Polygon的Option设置
            })
        },

        // 重置区域
        clearArea() {
            const that = this
            this.polygon = []
            this.myMap.clearMap()
            this.myMap.remove(this.mouseTool)
            // this.mouseTool.close(true)
            this.mouseTool = new AMap.MouseTool(this.myMap)
            this.mouseTool.close(true) // 关闭，并清除覆盖物
            // this.mouseTool.polygon()
            this.getPolygon()
            this.getLines()
            // this.getPont()
        },
        // 打点
        potintMaps() {
            const self = this
            if (this.watchLongitude && this.watchLatitude) {
                try {
                    self.myMap.remove(self.marker)
                } catch (err) {}
                self.marker = new AMap.Marker({
                    icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                    position: [
                        Number(this.watchLongitude),
                        Number(this.watchLatitude),
                    ],
                })
                self.myMap.add(self.marker)
                self.myMap.setFitView()
            }
        },
        // 打点
        getPont() {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {}

            self.marker = new AMap.Marker({
                icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [
                    Number(self.formData.longitude),
                    Number(self.formData.latitude),
                ],
            })
            // let customerTypeName = ""
            // self.typeList.forEach((item) => {
            //     if (this.formData.customerType == item.value) {
            //         customerTypeName = item.label
            //     }
            // })
            // this.infoWindow = new AMap.InfoWindow({
            //     offset: new AMap.Pixel(0, -30),
            // })
            // self.marker.content = `
            //       <div style="background: #ffffff; padding: 12px;border-radius: 5px;opacity: 0.7;">
            //           <p>姓名：${formData.customerName}</p>
            //           <p>用户类型：${customerTypeName}</p>
            //           <p>联系电话：${formData.phone}</p>
            //           <p>地址：${formData.address}</p>
            //       </div>
            //   `

            // self.marker.marker.on("click", this.markerClick)
            // self.markers.push(marker)
            // this.infoWindow.open(this.myMap, e.target.getPosition())
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },
        markerClick(e) {
            this.infoWindow.setContent(e.target.content)
            this.infoWindow.open(this.myMap, e.target.getPosition())
        },
        // 初始化
        loadMap() {
            const that = this
            return new Promise((resolve, reject) => {
                this.myMap = new AMap.Map("container2", {
                    zoom: 15,
                    zooms: [7, 20],
                    pitch: 53,
                    defaultCursor: "default",
                    viewMode: "3D",
                    defaultCursor: "pointer",
                    showBuildingBlock: false,
                    expandZoomRange: true,
                    center: [117.179071, 31.817215],
                    // center: [that.formData.longitude, that.formData.latitude], //初始化地图中心点
                })
                this.mouseTool = new AMap.MouseTool(this.myMap)
                resolve()
            })
        },
        // 轨迹
        getLines() {
            // alert(1)
            let data = this.records
            const self = this
            // self.potintMap(data[0].longitude, data[0].latitude)
            try {
                self.myMap.remove(self.object3Dlayer)
            } catch (err) {}
            self.line3D = {}
            self.object3Dlayer = {}
            self.object3Dlayer = new AMap.Object3DLayer({ zIndex: 10 })

            self.myMap.add(self.object3Dlayer)

            self.line3D = new AMap.Object3D.Line()
            self.line3D.transparent = true

            let geometry = self.line3D.geometry
            for (var i = 0; i < data.length; i++) {
                let origin = self.myMap.lngLatToGeodeticCoord([
                    data[i].longitude,
                    data[i].latitude,
                ])

                geometry.vertices.push(origin.x, origin.y, 0)
                geometry.vertexColors.push(1, 0, 0, 10)
                let lineDe = {}
                if (i == 0) {
                    lineDe = data[0]
                } else {
                    let b = i - 1
                    lineDe = data[b]
                }
                let des = self.myMap.lngLatToGeodeticCoord([
                    lineDe.longitude,
                    lineDe.latitude,
                ])
                geometry.vertices.push(des.x, des.y, 0)
                geometry.vertexColors.push(1, 0, 0, 1)
            }

            self.object3Dlayer.add(self.line3D)
        },
        // 打点
        potintMap(longitude, latitude) {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {}
            self.marker = new AMap.Marker({
                // icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [longitude, latitude],
                zoom: 15,
            })
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },
        // 画区域
        getPolygon() {
            return new Promise((resolve, reject) => {
                const self = this
                //  let polygon = [
                // "116.79455:31.873211",
                //   "117.547113:31.92451",
                //   "116.783563:31.452416",
                //  "117.519647:31.358648",
                //  ]
                let polygonArr = []
                resolve(self.polygon)
                self.polygon.forEach((e) => {
                    polygonArr.push(e.split(":"))
                })
                // polygon.forEach((e) => {
                //     polygonArr.push(e.split(":"))
                // })
                var polygons = new AMap.Polygon({
                    map: self.myMap,
                    path: polygonArr, //设置多边形边界路径
                    strokeColor: "#2785dc", //线颜色
                    strokeOpacity: 0.2, //线透明度
                    strokeWeight: 3, //线宽
                    fillColor: "#2785dc", //填充色
                    fillOpacity: 0.35, //填充透明度
                })
                // polygon = polygons
                // this.polygon = polygons
            })
        },
    },
}
</script>

<style lang="less" scoped>
.loc-1 {
    width: 98%;
    margin-left: 2%;
}
.topFlex {
    display: flex;
    .topLeft {
        flex: 1;
    }
    .topRight {
        margin-bottom: 20px;
        .ml20 {
            margin-left: 20px;
        }
    }
}
.tabBox {
    width: 400px;
    height: 130px;
    position: absolute;
    right: 0px;
    top: 0px;
    background: #fff;
    z-index: 2000;
}
.el-input--prefix .el-input__inner{
    border: 1px solid #000;
}
</style>
